module.exports = __webpack_public_path__ + "img/lingdang.dbc6ccdf.png";